import styled from "styled-components/macro";

export const TextAreaContainer = styled.div(() => ({
  maxWidth: "100%",
}));

export const Title = styled.label(({ theme, hasError }) => ({
  fontSize: "16px",
  display: "flex",
  color: hasError ? theme.color.feedback.error : theme.color.neutral["02"],
  marginBottom: "8px",
  fontFamily: "Rawline",
  alignItems: "center",
  fontWeight: "500",
  lineHeight: "150%",
  letterSpacing: 0,
  [theme.breakpoint.md()]: {
    fontSize: "18px",
  }
}));

export const StyledTextArea = styled.textarea(({ theme, hasError }) => ({
  border: `1px solid ${
    hasError ? theme.color.feedback.error : theme.color.neutral["04"]
  }`,
  boxSizing: "border-box",
  borderRadius: "4px",
  flexGrow: 0,
  margin: "8px 0px",
  color: hasError ? theme.color.feedback.error : theme.color.neutral["03"],
  fontWeight: 500,
  fontSize: "18px",
  background: theme.color.neutral["08"],
  minHeight: "75px",
  width: "100%",
  padding: "18px 12px",
}));

export const ErrorText = styled.p(({ theme }) => ({
  color: theme.color.feedback.error,
  fontSize: "14px",
  margin: 0
}));

export const TextTip = styled.p(({ theme }) => ({
  color: theme.color.neutral["03"],
  fontSize: "14px",
  marginTop: "0px",
}));
